import { useState, useEffect } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";

export default function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { login } = useAuth();

  useEffect(() => {
    const savedError = localStorage.getItem("loginError");
    if (savedError) {
      setError(savedError);
      localStorage.removeItem("loginError"); // Remove após usar
    }
  }, []);

  const handleSubmit = async () => {
    if (!email || !password) {
      const errorMsg = "Por favor, preencha todos os campos";
      setError(errorMsg);
      localStorage.setItem("loginError", errorMsg);
      return;
    }

    try {
      setLoading(true);
      setError("");
      localStorage.removeItem("loginError"); // Remove erro anterior
      await login({ email, password });
      // Redirecionamento é feito automaticamente no AuthContext
    } catch (err) {
      const errorMsg =
        err instanceof Error ? err.message : "Erro ao fazer login";
      setError(errorMsg);
      localStorage.setItem("loginError", errorMsg); // Persiste o erro
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen  relative overflow-hidden flex items-center justify-center">
       <div className="hidden lg:block absolute left-0 top-0 h-full w-2/4">
        <img
          src="/bg_login.png"
          alt="FAPITEC|SE"
          className="w-full h-full object-cover"
        />
        <div className="absolute left-0 top-0 h-full w-full bg-gradient-to-l from-white/100 via-white/10 to-transparent" />
      </div>

 

       <div className="hidden lg:block absolute left-32 top-1/2 transform -translate-y-1/2">
        <img
          src="/faptec_logo.png"
          alt="FAPITEC|SE"
          className="max-w-md h-auto"
        />
      </div>

      <div className="rounded-lg p-6 w-full max-w-md z-10 lg:mr-15 lg:absolute lg:right-0 lg:top-1/2 lg:transform  lg:-translate-x-1/2 lg:-translate-y-1/2">
        <div className="flex flex-col items-center mb-8">
          <img
            src="/login_logo.png"
            alt="FAPITEC|SE"
            className="max-md:w-4/5 max-w-xs h-auto mb-4"
          />
        </div>

        {/* Form */}
        <div className="space-y-4">
          <div>
            <input
              type="email"
              placeholder="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-900 focus:border-transparent"
            />
          </div>

          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-900 focus:border-transparent pr-12"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          {/* Mensagem de erro */}
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm mt-4">
              {error}
            </div>
          )}

           <div className="flex flex-col sm:flex-row gap-4 mt-6">
            <button
              onClick={() => (window.location.href = "/esqueci-senha")}
              disabled={loading}
              className="flex-1 bg-white text-blue-900 py-3 rounded-md font-semibold border border-blue-900 hover:bg-gray-100 transition-colors disabled:opacity-50"
            >
              Esqueci minha senha
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="flex-1 bg-blue-900 text-white py-3 rounded-md font-semibold hover:bg-blue-800 transition-colors disabled:opacity-50"
            >
              {loading ? "Entrando..." : "Entrar"}
            </button>
          </div>
        </div>

        <p className="text-center text-sm text-gray-600 mt-6">
          Para acessar o sistema FAPITEC você precisa estar cadastrado. Caso não
          possua cadastro,{" "}
          <span
            className="text-blue-900 underline cursor-pointer hover:text-blue-700"
            onClick={() => (window.location.href = "/cadastro")}
          >
            clique aqui
          </span>
          .
        </p>
      </div>
    </div>
  );
}
